import * as Sentry from '@sentry/react';

import { useEffect } from 'react';

import useViewer from '../../hooks/useViewer/useViewer';
import useTour from '../../hooks/useTour/useTour';
import { useSetAtom } from 'jotai';
import { modalContentAtom } from '../../atoms/menuItemContent.atom';
import isPartOfTour from '../../utils/isPartOfTour/isPartOfTour';

// Used to intercept old APP API used in floorplans widget
const InterceptApp = () => {
  const { viewer } = useViewer();
  const tour = useTour();
  const setModalContent = useSetAtom(modalContentAtom);

  useEffect(() => {
    Object.defineProperty(window, 'APP', {
      configurable: true,
      get() {
        return {
          customViewer: {
            instance: {
              setPano: (panoId: string) => {
                if (
                  !tour.carousel.pano.some((pano) => pano.panoid === panoId) &&
                  !isPartOfTour(panoId, tour)
                ) {
                  Sentry.withScope((scope) => {
                    scope.setTag('panoId', panoId);

                    Sentry.captureException(
                      new Error('setPano called with invalid panoId')
                    );
                  });

                  return;
                }

                viewer?.setPano(panoId);
                setModalContent('');
              },
            },
          },
        };
      },
    });
  }, [setModalContent, tour, viewer]);

  return null;
};

export default InterceptApp;
